import { createI18n } from "vue-i18n";
import en from "./locales/en";
import th from "./locales/th";

/**
 * Thai leads, English falls back.
 *
 * `legacy: false` selects the Composition API mode, which is the one with real TypeScript support
 * — `en` is the schema, so a key present in English and missing in Thai is a compile error rather
 * than a raw key rendered on a screen an operator is reading.
 *
 * Line height is NOT set here. Thai stacks vowels above and below the consonant line and puts tone
 * marks on top of those, so it needs 10–15% more leading than Latin — that is one `:lang(th)` rule
 * in `tokens.css`, applied by the `lang` attribute, not a per-component concern.
 */
export const i18n = createI18n<[typeof en], "th" | "en">({
  legacy: false,
  locale: "th",
  fallbackLocale: "en",
  messages: { en, th },
});

export type Locale = "th" | "en";
